module.exports = __webpack_public_path__ + "img/ico_mysoho.ae1915a6.svg";